<template>
    <div class="container">
        <div class="pt-5">
            <h1 class="h3">Settings</h1>
            <div class="py-2">
                <settings-menu></settings-menu>
            </div>
            <div class="row py-3 border-bottom">
                <div class="col-md-6 col-sm-12">
                    <h3 class="h3">Payments settings</h3>
                    <small>View and update your payments details </small>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="float-right">
                        <button @click="saveSettingsDetails" class="btn btn-primary px-3">Save Changes</button>
                    </div>
                </div>
            </div>
            <div class="container text-left mb-5">
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Accept Cash payments <small class="text-danger">*</small></h6>
                        <small>
                                Allow customers to pay using cash
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="paymentDetails.cashEnabled.enabled" id="enable-cash">
                            <label class="custom-control-label" for="enable-cash"><small>Accept Cash</small></label>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Accept Card payments <small class="text-danger">*</small></h6>
                        <small>
                                Allow customers to pay using cards. Note: For now you will use your PDQ Machine to transact 
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="paymentDetails.cardsEnabled.enabled" id="enable-cards">
                            <label class="custom-control-label" for="enable-cards"><small>Accept Cards</small></label>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Accept Buy Now Pay Later <small class="text-danger">*</small></h6>
                        <small>
                                Allow customers to pay for items or services at later date.
                                You will follow up with your customers
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="paymentDetails.bnplEnabled.enabled" id="enable-bnpl">
                            <label class="custom-control-label" for="enable-bnpl"><small>Accept BNPL</small></label>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">M-Pesa payments <small class="text-danger">*</small></h6>
                        <small>
                              Allow customers to pay via M-Pesa
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="paymentDetails.mpesaEnabled.enabled" id="enable-mpesa">
                            <label class="custom-control-label" for="enable-mpesa"><small>Accept M-Pesa</small></label>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Setup M-Pesa <small class="text-danger">*</small></h6>
                        <small>
                              Choose Paybill/Till Number to use
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="paymentDetails.useDukakitShortcode" id="mpesa-switch">
                            <label class="custom-control-label" for="mpesa-switch"><small>We have our own Paybill/Till</small></label>
                        </div>
                    </div>
                </div>
                <div v-if="paymentDetails.useDukakitShortcode" class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1"> Integration <small class="text-danger">*</small></h6>
                        <small>
                             You can leave this as is if you will use phone to verify payments
                            </small>
                            <p><small>Only proceed if you are confident in the process; otherwise, <a href="https://api.whatsapp.com/send/?phone=254725445898&text=Hello%20Team%20Dukakit,%20I%20need%20assistance%20on%20Mpesa%20Integration,%20c-id=">contact us on WhatsApp for assistance.</a></small></p> 
        
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="paymentDetails.mpesaDetails.haveApiKeys" id="mpesa-integrate">
                            <label class="custom-control-label" for="mpesa-integrate"><small>I know how to integrate</small></label>
                        </div>
                    </div>
                </div>
                <div v-if="paymentDetails.mpesaDetails.haveApiKeys">
                    <div class="row py-3 border-bottom">
                        <div class="col-md-6 col-sm-12">
                            <h6 class="py-1"> Shortcode <small class="text-danger">*</small></h6>
                            <small>
                              Your paybill/Till
                            </small>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <input class="form-control" v-model="paymentDetails.mpesaDetails.shortcode" />
                        </div>
                    </div>
                    <div class="row py-3 border-bottom">
                        <div class="col-md-6 col-sm-12">
                            <h6 class="py-1"> Consumer Secret <small class="text-danger">*</small></h6>
                            <small>
                              You get this from your Daraja Safaricom portal
                            </small>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <input class="form-control" v-model="paymentDetails.mpesaDetails.consumer_secret" />
                        </div>
                    </div>
                    <div class="row py-3 border-bottom">
                        <div class="col-md-6 col-sm-12">
                            <h6 class="py-1"> Consumer Key <small class="text-danger">*</small></h6>
                            <small>
                                You get this from your Daraja Safaricom portal
                            </small>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <input class="form-control" v-model="paymentDetails.mpesaDetails.consumer_key" />
                        </div>
                    </div>
                    <div class="row py-3 border-bottom">
                        <div class="col-md-6 col-sm-12">
                            <h6 class="py-1"> Keyphrase <small class="text-danger">*</small></h6>
                            <small>
                              This is shared on email by Safaricom
                            </small>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <input class="form-control" v-model="paymentDetails.mpesaDetails.keyphrase" />
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "profile",
        data() {
            return {
                paymentDetails: {
                    cashEnabled: {},
                    mpesaEnabled: {},
                    cardsEnabled: {},
                    bnplEnabled: {},
                    useDukakitShortcode: 0,
                    mpesaDetails: {
                        shortcode: '',
                        keyphrase: '',
                        haveApiKeys: 0
                    }
                }
            }
        },
        mounted() {
            this.getPaymentDetails()
            this.getCompanySettings()
            this.getMpesaConfigs()
        },
        watch: {
            "paymentDetails.mpesaDetails.haveApiKeys" : function (before,after) {
                
            } 
        },
        methods: {
            getPaymentDetails() {
                axios.get('/api/payments')
                    .then(results => {
                        const paymentModes = results.data
                        
                        this.paymentDetails.cashEnabled = paymentModes.find(this.checkCashEnabled)
                        this.paymentDetails.mpesaEnabled = paymentModes.find(this.checkMpesaEnabled)
                        this.paymentDetails.bnplEnabled = paymentModes.find(this.checkBnplEnabled)
                        this.paymentDetails.cardsEnabled = paymentModes.find(this.checkCardsEnabled)
                 
                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            getCompanySettings() {
                axios.get('/api/settings')
                    .then(results => {
                        const companyDetails = results.data
                        this.paymentDetails.useDukakitShortcode = companyDetails.use_dukakit_paybill
                        
                 
                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            getMpesaConfigs() {
                axios.get('/api/mpesa-configs')
                    .then(results => {
                        const mpesaConfigs = results.data
                        this.paymentDetails.mpesaDetails = mpesaConfigs
                       
                 
                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            checkCashEnabled(item)
            {
                if(item.payment_method.toLowerCase() === 'cash')
                {
                    return item
                }
            },
            checkBnplEnabled(item)
            {
                if(item.payment_method.toLowerCase() === 'buy now pay later')
                {
                    return item
                }
            },
            checkCardsEnabled(item)
            {
                if(item.payment_method.toLowerCase() === 'cards')
                {
                    return item
                }
            },
            checkMpesaEnabled(item)
            {
                if(item.payment_method.toLowerCase() === 'm-pesa')
                {
                    return item
                }
            },
            saveSettingsDetails() {
                axios.post('/api/settings/payments', { ...this.paymentDetails
                }).then(results => {
                    this.$toasts.push({
                        type: 'success',
                        message: "Payment details have updated"
                    })
                }).catch(errors => {})
            }
        },
    }
</script>

<style scoped>

</style>